/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Ref, watch } from '@nuxtjs/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import IBiuroBaseInfo from '~/components/biura/types/IBiuroBaseInfo';
import IMapBiuraServiceConfig from '~/components/map/types/IMapBiuraServiceConfig';

const { useGetters } = createNamespacedHelpers('biura');

const fetchMarkersFromStore = async (params: IMapBiuraServiceConfig) => {
  const { markersInnerState } = params;
  const { koordynatyNaMape: markersFromStore } = useGetters(['koordynatyNaMape']) as { koordynatyNaMape: Ref<IBiuroBaseInfo[]> };

  watch(
    markersFromStore,
    (newValue, oldValue) => {
      markersInnerState.markers = markersFromStore.value;
    },
    { immediate: true },
  );
};
export default fetchMarkersFromStore;
